<template>
  <div class="col-8 col-lg-3 d-flex flex-auto justify-content-end">
  <ais-instant-search
    v-if="searchClient"
    class="sicss-container"
    :index-name="indexName"
    :search-client="searchClient"
    :search-function="searchFunction"
  >
    <div
      :class="[
        smallSearchIsOpened ? 'opened' : 'closed',
        'menu-menu__item header-search-bar d-flex',
      ]"
    >
      <!-- search bar -->
      <ais-autocomplete ref="searchAuto">
        <template v-slot:default="{ currentRefinement, indices, refine }">
          <b-input-group>
            <b-form-input
              type="search"
              ref="suggestInput"
              :value="currentRefinement"
              placeholder="Search for a vehicle..."
              @input="refine"
              autocomplete="off"
              @focusin="suggestState()"
              @focusout="handleFocusOut()"
              @keyup.enter="searchState(currentRefinement)"
              style="border-radius: 0 5.5px 5.5px 0; height: inherit;"
            ></b-form-input>

            <template v-slot:prepend>
              <b-input-group-text class="header-search-enter" @click="searchState(currentRefinement)">
                <b-icon icon="search" font-scale="2"></b-icon>
              </b-input-group-text>
            </template>
          </b-input-group>

          <div v-if="currentRefinement && suggestOpenable" class="autopanel">
            <div class="hits">
              <ul
                v-for="index in indices"
                :key="index.label"
                class="list-group"
              >
                <h4>Results</h4>
                <li v-show="index.hits.length == 0" class="list-group-item">
                  <em>No matches...</em>
                </li>
                <li
                  v-for="hit in index.hits"
                  :key="hit.objectID"
                  class="list-group-item"
                >
                  <a :href="hitLink(hit)" class="stretched-link">
                    <div class="suggestion-content">
                      <div class="suggestion-thumbnail">
                        <img :src="hit.photos ? hit.photos.split('|')[0] : ['U', 'T'].includes(hit.stock_number) ? '/static/images/tCComingSoon.webp' : '/static/images/hComingSoon.webp'" alt="clawson honda" width="100" loading="lazy" />
                      </div>
                      <div class="suggestion-details">
                        <strong>
                          <span v-if="hit.new">New</span>
                          <span
                            >{{ hit.year }} {{ hit.make }} {{ hit.model }}</span
                          >

                          <span v-if="hit.style">{{ hit.style }}</span>
                          <span v-if="hit.door_count"
                            >{{ hit.door_count }}D</span
                          >
                          <span v-if="hit.body">{{ hit.body }}</span>
                        </strong>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </ais-autocomplete>
    </div>
    <b-icon
      icon="search"
      class="header-search-sm"
      @click="toggleSmallSearch()"
    ></b-icon>
  </ais-instant-search>
  </div>
</template>

<script>
import { createAutocompleteClient, getIndexName } from "./ctgSearch/clientFactory";

export default {
  data: () => ( {
    // searchClient + indexName populated by created() below (factory is
    // async; hosted mode lazy-loads algoliasearch/lite as a separate
    // webpack chunk). Template guards on `searchClient` so the header
    // slot reserves its layout space while the Promise resolves.
    searchClient        : null,
    indexName           : null,
    suggestOpenable     : true,
    smallSearchIsOpened : false,
  } ),
  async created() {
    const [ client, indexName ] = await Promise.all( [
      createAutocompleteClient(),
      getIndexName(),
    ] );
    this.indexName    = indexName;
    this.searchClient = client;
  },

  mounted() {
    $(".dropdown-menu").click(function (e) {
      e.stopPropagation();
    });
  },

  methods: {
    // closes suggest box for user to browse results
    // but not lose results.
    toggleSmallSearch() {
      this.smallSearchIsOpened = !this.smallSearchIsOpened;

      if (this.smallSearchIsOpened) {
        this.$refs.suggestInput.focus();
      }
    },

    searchFunction(helper) {
      // makes sure crv/hrv values are properly resolved in input.
      switch (helper.state.query) {
        case "crv":
          helper.setQuery("cr-v").search();
          break;
        case "hrv":
          helper.setQuery("hr-v").search();
          break;
        default:
          helper.search(helper.state.query);
      }
    },

    hitLink(hit) {
      if (hit.new) {
        return "/search/new/" + hit.vin + "/";
      }

      if (
        !hit.new &&
        (hit.certification == "Clawson Certified Pre-Owned" ||
          hit.certification == "Certified Pre-Owned")
      ) {
        return "/search/certified/" + hit.vin + "/";
      } else {
        return "/search/used/" + hit.vin + "/";
      }
    },

    searchState(query) {
      this.searchClient.initIndex(this.indexName)
        .search(query, { filters: "new:true" })
        .then(({ hits }) => {
          // result count check.
          if (hits.length == 0) {
            window.location.href = "/search/?new=false&query=" + query;
          } else {
            window.location.href = "/search/?new=true&query=" + query;
          }
        })
        .catch((error) => {
          console.error("index check error: ", error);
        });
    },

    suggestState() {
      this.suggestOpenable = true;
    },

    handleFocusOut() {
      // give state time to think whether or not
      // user clicked on item or if focused out of search.
      setTimeout(() => {
        this.suggestOpenable = false;
      }, 400);
    },
  },
};
</script>

<style scoped>
  .input-group-prepend {
    height: unset !important;
    .input-group-text {
      background-color: #fff !important;
      border-radius: 5.5px 0 0 5.5px !important;
    }
  }
</style>